<template>
    <div class="mb-6">
        <a class="rounded-sm" v-if="isClientSelected" :href="illuminateConnector" tabindex="-1">
            <img src="@/assets/ren-logo-w-tagline.svg" class="ren-logo" role="presentation"
                alt="Renaissance Learning" />
        </a>
        <img v-else src="@/assets/ren-logo-w-tagline.svg" class="ren-logo" role="presentation"
            alt="Renaissance Learning" />
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'EmployeeLogin',
    computed: {
        ...mapGetters(['isClientSelected', 'illuminateConnector'])
    }

}
</script>